module.exports = __webpack_public_path__ + "37218829b3a988811a6c668780a30520.svg";